import { Link } from '@tanstack/react-router';
import { useSyncStatus } from '@kapture/client-core';
import { cn } from '@/lib/cn';

export function OnlineIndicator() {
  const { online, pending } = useSyncStatus();
  return (
    <Link
      to="/sync"
      preload="intent"
      title={online ? 'Connected — tap to view sync queue' : 'Offline — changes are queued'}
      className={cn(
        'flex items-center gap-2 rounded-full border px-3 py-1 font-mono text-[10px] uppercase tracking-wider transition-colors',
        online
          ? 'border-good/30 bg-good/10 text-good hover:bg-good/15'
          : 'border-warn/30 bg-warn/10 text-warn hover:bg-warn/15',
      )}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', online ? 'bg-good' : 'bg-warn')} />
      {online ? 'Online' : 'Offline'}
      {pending > 0 && <span className="text-text-dim">· {pending} queued</span>}
    </Link>
  );
}
